export default "__VITE_ASSET__CtFGKSVS__"